import {Directive} from '@angular/core';
import {NG_VALIDATORS, UntypedFormControl, Validator} from '@angular/forms';
import {isEmail} from 'src/app/utilities/email';

@Directive({    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '[cmnEmail][formControlName], [cmnEmail][formControl], [cmnEmail][ngModel]',
    providers: [{provide: NG_VALIDATORS, useExisting: CmnEmailDirective, multi: true}]
})
export class CmnEmailDirective implements Validator {
    validate(c: UntypedFormControl): { [key: string]: any } {
        return c.value && !this.isEmail(c.value) ? {invalid: true} : null;
    }

    isEmail(input?: string): boolean {
        return isEmail(input);
    }
}
